<nav class="navbar navbar-expand-lg" [ngClass]="{'navbar-dark' : collapsed, 'navbar-light' : !collapsed}">
  <div class="container-fluid container" style="margin-top:10px;">
    <span class="navbar-logo navbar-img">
      <a [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active">
        <!-- width/height : sans eux, le bandeau n'a pas de hauteur tant que le SVG
             n'est pas chargé, puis grandit d'un coup (~40 px en mobile) et DESCEND
             LA PAGE ENTIÈRE — un décalage de mise en page sur chacune des URL du
             site. Les attributs ne fixent pas la taille affichée (c'est le CSS qui
             la donne : 165 px, 105 px ou 85 px selon la largeur d'écran), ils
             donnent seulement le RATIO d'avance au navigateur.
             La hauteur suit le même ternaire que `src` car les deux fichiers n'ont
             pas les mêmes proportions : logo-white.svg est en 109x51, alors que
             logo-default.svg est en 109x71. -->
        <img src="{{collapsed ? 'assets/logo/logo-white.svg' : 'assets/logo/logo-default.svg'}}"
      width="109" [attr.height]="collapsed ? 51 : 71"
      alt="Logo The Door Man"></a></span>
    <button class="navbar-toggler" type="button" aria-controls="navbarContent" [attr.aria-expanded]="!collapsed"
            aria-label="Toggle navigation" (click)="collapsed = !collapsed">
      <span class="toggler-icon top-bar"></span>
      <span class="toggler-icon middle-bar"></span>
      <span class="toggler-icon bottom-bar"></span>
    </button>
    <div class="navbar-collapse" [class.collapse]="collapsed" id="navbarContent">
      <ul class="navbar-nav ms-auto no-bullet">
        <li class="nav-item nav-button" ngbDropdown #deviceDrop="ngbDropdown">
          <a class="nav-link " tabindex="0" ngbDropdownToggle id="navbarDropdown1" role="button">
            Acheter
            <span *ngIf="!collapsed">
              <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
            </span>
          </a>
          <div (mouseleave)="$event.stopPropagation(); deviceDrop.close();" ngbDropdownMenu
               aria-labelledby="navbarDropdown1" class="dropdown-menu">
            <app-menu-acheter></app-menu-acheter>
          </div>
        </li>

        <li class="nav-item nav-button" ngbDropdown #deviceDrop1="ngbDropdown">
          <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarDropdown2" role="button">
            Vendre
            <span *ngIf="!collapsed">
              <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
            </span>
          </a>
          <div ngbDropdownMenu (mouseleave)="$event.stopPropagation(); deviceDrop1.close();"
               aria-labelledby="navbarDropdown2" class="dropdown-menu dec100">
            <app-menu-vendre></app-menu-vendre>
          </div>
        </li>

        <li class="nav-item nav-button" ngbDropdown #deviceDrop2="ngbDropdown">
          <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarDropdown3" role="button">
            Louer
            <span *ngIf="!collapsed">
              <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
            </span>
          </a>
          <div ngbDropdownMenu (mouseleave)="$event.stopPropagation(); deviceDrop2.close();"
               aria-labelledby="navbarDropdown3" class="dropdown-menu dec200">
            <app-menu-location></app-menu-location>
          </div>
        </li>
        <li class="nav-item nav-button" ngbDropdown #deviceDrop3="ngbDropdown">
          <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarDropdown4" role="button">
            A propos de nous
            <span *ngIf="!collapsed">
              <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
            </span>
          </a>
          <div ngbDropdownMenu (mouseleave)="$event.stopPropagation(); deviceDrop3.close();"
               aria-labelledby="navbarDropdown4" class="dropdown-menu dec300">
            <app-menu-propos-nous></app-menu-propos-nous>
          </div>
        </li>
        <li class="menu-cta">
          <div class="menu-cta-row">
            <div class="menu-cta-row-item" style="margin-left: auto;">
<!--                <div class="menu-cta-row-item-icon">-->
<!--                  <a [routerLink]="['/blog']" class="lien-blanc-txt">-->
<!--                      <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                        <path-->
<!--                          d="M16.3125 0.375H5.0625C4.11328 0.375 3.375 1.14844 3.375 2.0625V13.875C3.375 14.5078 2.84766 15 2.25 15C1.61719 15 1.125 14.5078 1.125 13.875V3.1875C1.125 2.90625 0.84375 2.625 0.5625 2.625C0.246094 2.625 0 2.90625 0 3.1875V13.875C0 15.1406 0.984375 16.125 2.25 16.125H15.1875C16.7344 16.125 18 14.8945 18 13.3125V2.0625C18 1.14844 17.2266 0.375 16.3125 0.375ZM16.875 13.3125C16.875 14.2617 16.1016 15 15.1875 15H4.18359C4.35938 14.6836 4.5 14.2969 4.5 13.875V2.0625C4.5 1.78125 4.74609 1.5 5.0625 1.5H16.3125C16.5938 1.5 16.875 1.78125 16.875 2.0625V13.3125ZM9.5625 9.9375H6.1875C5.87109 9.9375 5.625 10.2188 5.625 10.5C5.625 10.8164 5.87109 11.0625 6.1875 11.0625H9.5625C9.84375 11.0625 10.125 10.8164 10.125 10.5C10.125 10.2188 9.84375 9.9375 9.5625 9.9375ZM15.1875 9.9375H11.8125C11.4961 9.9375 11.25 10.2188 11.25 10.5C11.25 10.8164 11.4961 11.0625 11.8125 11.0625H15.1875C15.4688 11.0625 15.75 10.8164 15.75 10.5C15.75 10.2188 15.4688 9.9375 15.1875 9.9375ZM9.5625 12.1875H6.1875C5.87109 12.1875 5.625 12.4688 5.625 12.75C5.625 13.0664 5.87109 13.3125 6.1875 13.3125H9.5625C9.84375 13.3125 10.125 13.0664 10.125 12.75C10.125 12.4688 9.84375 12.1875 9.5625 12.1875ZM15.1875 12.1875H11.8125C11.4961 12.1875 11.25 12.4688 11.25 12.75C11.25 13.0664 11.4961 13.3125 11.8125 13.3125H15.1875C15.4688 13.3125 15.75 13.0664 15.75 12.75C15.75 12.4688 15.4688 12.1875 15.1875 12.1875ZM14.625 2.625H6.75C6.11719 2.625 5.625 3.15234 5.625 3.75V7.125C5.625 7.75781 6.11719 8.25 6.75 8.25H14.625C15.2227 8.25 15.75 7.75781 15.75 7.125V3.75C15.75 3.15234 15.2227 2.625 14.625 2.625ZM14.625 7.125H6.75V3.75H14.625V7.125Z"-->
<!--                          fill="white"/>-->
<!--                      </svg>-->
<!--                  </a>-->
<!--                </div>-->
<!--                <div class="menu-cta-row-item-label fw-semibold">-->
<!--                  <a [routerLink]="['/blog']" class="lien-blanc-txt txt-act">Actualités immo</a>-->
<!--                </div>-->
              <div class="menu-cta-row-item-label fw-semibold">
                <a href="https://thedoorman-recrute.fr" target="_blank" class="lien-blanc-txt txt-act"

                >
                  Nous rejoindre
                </a>
              </div>
            </div>
            <div *ngIf="getUser()" class="menu-cta-row-item p-0">
              <div class="nav-item nav-button" ngbDropdown #deviceDrop1="ngbDropdown">
                <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarDropdownCompte" role="button">
                  <!-- Changer l'icone de connection pour celui fourni par Cyrille -->
                  <img class="rounded-circle mx-2" width="32" height="32" alt=""
                       [src]="'../../../assets/resources/web/images/design/connected.png'">
                  <span>
                    {{ (getUser().prenom.length>6)? (getUser().prenom | slice:0:6)+'...':(getUser().prenom)}}
                  </span>
                  <span *ngIf="!collapsed">
                    <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
                  </span>
                </a>
                <div ngbDropdownMenu aria-labelledby="navbarDropdownCompte" class="dropdown-menu w-100">
                  <div class="menu-main-item p-2">
                    <a [routerLink]="['/connexion']" class="lien-txt">
                      <div class="menu-main-item-text">
                        <span class="bold-base">Tableau de bord</span>
                      </div>
                    </a>
                  </div>
                  <div class="menu-main-item p-2">
                    <a [routerLink]="['/deconnexion']" class="lien-txt">
                      <div class="menu-main-item-text">
                        <span class="bold-base">Se déconnecter</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!user" class="menu-cta-row-item">
              <div class="menu-cta-row-item-icon">
                <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 9.25C10.4609 9.25 12.5 7.24609 12.5 4.75C12.5 2.28906 10.4609 0.25 8 0.25C5.50391 0.25 3.5 2.28906 3.5 4.75C3.5 7.24609 5.50391 9.25 8 9.25ZM8 1.375C9.82812 1.375 11.375 2.92188 11.375 4.75C11.375 6.61328 9.82812 8.125 8 8.125C6.13672 8.125 4.625 6.61328 4.625 4.75C4.625 2.92188 6.13672 1.375 8 1.375ZM9.75781 10.9375H6.20703C2.83203 10.9375 0.125 13.6797 0.125 17.0547C0.125 17.7227 0.652344 18.25 1.32031 18.25H14.6445C15.3125 18.25 15.875 17.7227 15.875 17.0547C15.875 13.6797 13.1328 10.9375 9.75781 10.9375ZM14.6445 17.125H1.32031C1.28516 17.125 1.25 17.0898 1.25 17.0547C1.25 14.3125 3.46484 12.0625 6.20703 12.0625H9.75781C12.5 12.0625 14.75 14.3125 14.75 17.0547C14.75 17.0898 14.6797 17.125 14.6445 17.125Z"
                    fill="white"/>
                </svg>
              </div>
              <div role="button" [routerLink]="['/connexion']" routerLinkActive="router-link-active"
                   class="menu-cta-row-item-label fw-semibold">
                Mon compte
              </div>
            </div>
          </div>
          <!-- User non connecté -->
          <div *ngIf="user?.id == null" class="menu-cta-row flex-wrap">
            <button [routerLink]="['/amis-tdm/liste']" type="button" class="btn" [ngClass]="{'btn-outlined' : collapsed, 'btn-white-reverse' : !collapsed}">
              Mon Conseiller
            </button>
            <button
              [routerLink]="['/by-tdm']"
              class="btn btn-gold">
              Solution&nbsp;
              <span class="logo-hover">
                <img width="1238" height="582"
                  src="assets/logo/logo_bytdm_signature_noir.png"
                  alt="logo_bytdm"
                  class="logo-default img-fluid">

                <img width="1238" height="582"
                  src="assets/logo/logo_bytdm_signature_blanc.png"
                  alt="logo_bytdm"
                  class="logo-hovered img-fluid">
              </span>
            </button>
          </div>
          <!-- User connecté -->
          <div *ngIf="user?.id != null" class="menu-cta-row flex-wrap">
            <button [routerLink]="['/connexion']" type="button" class="btn btn-gold">
              Tableau de bord
            </button>
            <button [routerLink]="['/biens-a-vendre/page/1']" type="button" class="btn btn-secondary">
              Liste des biens
            </button>
          </div>



        </li>
      </ul>
    </div>
  </div>
</nav>
